var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('common-page',[_c('BomTree',{on:{"gotBom":function($event){_vm.needWarning=true}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }